module.exports = __webpack_public_path__ + "img/icon-pathplan-53ec9e83.svg";